import { useIntercom } from "./IntercomContext";
import { NotificationCircle } from "@medoma/components/NotificationCircle/NotificationCircle";
import HeadsetIcon from "@medoma/components/icons/HeadsetIcon";
import { IconButton } from "@medoma/components/Button/Button";
import styles from "./IntercomButton.module.scss";
import { useLingui } from "@lingui/react/macro";
import { LoadingOverlay } from "@medoma/components/Loading/Loading";
import * as Sentry from "@sentry/react";

export const IntercomButton = () => {
  const { unreadCount, showIntercom, isPending, isError } = useIntercom();
  const { t } = useLingui();

  const reportIntercomFailure = () =>
    Sentry.captureException(
      new Error("Intercom error when user clicked button"),
    );

  return (
    <div className={styles.buttonWrapper}>
      <LoadingOverlay show={isPending}>
        <IconButton
          aria-label={t`Support`}
          onClick={isError ? reportIntercomFailure : showIntercom}
        >
          <NotificationCircle
            placement="top-left"
            isVisible={unreadCount > 0}
            number={unreadCount}
          >
            <HeadsetIcon />
          </NotificationCircle>
        </IconButton>
      </LoadingOverlay>
    </div>
  );
};
